<template>
    <Numerics class="executions_trades">
        <div class="transaction_table_holder">
            <table cellspacing="0">
                <thead>
                    <tr>
                        <th>#</th>
                        <!-- <th>Instrument</th> -->
                        <th>ID</th>
                        <th>Order ID</th>
                        <th>External ID</th>
                        <th class="selectable" @click="$emit('changeSortFilters', 'executed_at')">Executed At <span class="asc_desc_arrow" v-if="sortFilters.column == 'executed_at'">{{ sortFilters.direction == 'asc' ? '&#8638;' : '&#8642;' }}</span></th>
                        <th>Market</th>
                        <!-- <th>Order Side</th>
                        <th>Order Type</th> -->
                        <th class="selectable number" @click="$emit('changeSortFilters', 'amount')">Amount <span class="asc_desc_arrow" v-if="sortFilters.column == 'amount'">{{ sortFilters.direction == 'asc' ? '&#8638;' : '&#8642;' }}</span></th>
                        <!-- <th>Execution Status</th>
                        <th>Date</th>
                        <th>Time</th> -->
                        <!-- <th>Metadata</th> -->
                        <th class="selectable number" @click="$emit('changeSortFilters', 'gross_trade_amount')">Gross Trade Amount <span class="asc_desc_arrow" v-if="sortFilters.column == 'gross_trade_amount'">{{ sortFilters.direction == 'asc' ? '&#8638;' : '&#8642;' }}</span></th>
                        <th class="selectable number" @click="$emit('changeSortFilters', 'price')">Price <span class="asc_desc_arrow" v-if="sortFilters.column == 'price'">{{ sortFilters.direction == 'asc' ? '&#8638;' : '&#8642;' }}</span></th>
                        <th class="selectable" @click="$emit('changeSortFilters', 'asset')">Asset <span class="asc_desc_arrow" v-if="sortFilters.column == 'asset'">{{ sortFilters.direction == 'asc' ? '&#8638;' : '&#8642;' }}</span></th>
                        <!-- <th>Customer ID</th> -->
                        <!-- <th>Account ID</th> -->
                        <!-- <th>Market ID</th>
                        <th>System ID</th>
                        <th>Created By System Member</th>
                        <th>Created By Customer Member</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(execution, index) in trades" :key="index" :class="isOdd(index) ? 'even': ''" @click="selectedExecution = execution">
                        <td>{{ index + 1 + "." }}</td>
                        <!-- <td>{{ order.instrument }}</td> -->
                        <td>{{ execution.id }}</td>
                        <td>{{ execution.order_id }}</td>
                        <td>{{ execution.external_id }}</td>
                        <td>{{ execution.executed_at.slice(0,10) + " " + execution.executed_at.slice(11,19) }}</td>
                        <td>{{ execution.short_name }}</td>
                        <!-- <td :class="setSideColor(execution.order_side)">{{ execution.order_side }}</td>
                        <td>{{ execution.order_type }}</td> -->
                        <td class="number">{{ execution.amount }}</td>
                        <!-- <td :class="setStatusColor(execution.execution_status)">{{ execution.execution_status }}</td>
                        <td>{{ execution.created_at }}</td> -->
                        <!-- <td>{{ execution.metadata }}</td> -->
                        <td class="number">{{ execution.gross_trade_amount }}</td>
                        <td class="number">{{ parseFloat(execution.price).toFixed(2) }}</td>
                        <td>{{ execution.asset_short_name }}</td>
                        <!-- <td>{{ execution.customer_id }}</td> -->
                        <!-- <td>{{ execution.account_id }}</td> -->
                        <!-- <td>{{ execution.market_id }}</td>
                        <td>{{ execution.system_id }}</td>
                        <td>{{ execution.created_by_system_member }}</td>
                        <td>{{ execution.created_by_customer_member }}</td> -->
                    </tr>
                </tbody>
            </table>
        </div>
        <Transition name="item_explorer">
            <div class="item_explorer" v-if="selectedExecution">
                <div class="header">
                    <h3> {{ "Trade: " + selectedExecution.id }} </h3>
                </div>
                <div class="settings">
                    <div class="settings_content">
                        <div class="info_setting">
                            <span class="label">ID:</span>
                            <span class="info">{{ selectedExecution.id }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Order ID:</span>
                            <span class="info">{{ selectedExecution.order_id }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Market:</span>
                            <span class="info">{{ selectedExecution.short_name }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Date:</span>
                            <span class="info">{{ selectedExecution.executed_at.slice(0,10) }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Time:</span>
                            <span class="info">{{ selectedExecution.executed_at.slice(11,19) }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Amount:</span>
                            <span class="info">{{ selectedExecution.amount }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Gross Trade Amount:</span>
                            <span class="info">{{ selectedExecution.gross_trade_amount }}</span>
                        </div>
                        <div class="info_setting">
                            <span class="label">Price:</span>
                            <span class="info">{{ selectedExecution.price + " " + selectedExecution.asset_short_name }}</span>
                        </div>
                    </div>
                </div>
                <div class="exit_options">
                    <input type="button" class="exit_option" value="Close" @click="closeExistingItemExplorer">
                </div>
            </div>
        </Transition>
    </Numerics>
</template>

<script>
    import Numerics from "@/components/slots/numerics-slot.vue";

    export default {
        props: {
            trades: {
                Type: Array
            },
            assets: {
                Type: Array
            },
            sortFilters: {
                Type: Object
            }
        },

        components: {
            Numerics
        },

        data() {
            return {
                selectedExecution: null
            }
        },

        methods: {
            closeExistingItemExplorer() {
                this.selectedExecution = null;
            },

            setSideColor(side) {
                if (side == "BUY") {
                    return "positive";
                }
                else if (side == "SELL") {
                    return "negative";
                }
            },

            setStatusColor(status) {
                // if (status == "Open") {
                //     return "positive";
                // }
                if (status == "FILLED") {
                    return "positive";
                }
                // else if (status == "Partially Filled") {
                //     return "pending";
                // }
                else if (status == "PENDING_SUBMISSION") {
                    return "pending";
                }
                else if (status == "REJECTED") {
                    return "negative";
                }
            },

            isOdd(num) {
                return num % 2 !== 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .executions_trades {
        width: 100%;
        // max-height: 800px;

        .transaction_table_holder {
            width: 100%;
            overflow: auto;

            table {
                width: 100%;
                overflow-x: auto;
    
                thead {
                    width: 100%;
    
                    tr {
                        position: sticky;
                        top: 0;
                        border-radius: 5px;
    
                        th {
                            // width: 14.285714%;
                            height: 10px;
                            font-size: 14px;
                            font-weight: 300;
                            text-align: left;

                            &.number {
                                text-align: right;
                            }

                            &.selectable {
                                &:hover {
                                    cursor: pointer;
                                    background-color: #444;
                                }
                            }
                        }
    
                        :first-child {
                            padding-left: 10px;
                        }
    
                        :last-child {
                            padding-right: 10px;
                        }
                    }
                }
    
                tbody {
                    width: 100%;
    
                    tr {
                        border-radius: 5px;
    
                        td {
                            height: 10px;
                            font-size: 12px;
                            font-weight: 500;
                            text-align: left;

                            &.number {
                                text-align: right;
                            }
    
                            input {
                                height: 30px;
                                padding: 4px 8px;
                                text-align: center;
                                font-size: 13px;
                            }
                        }
    
                        :first-child {
                            padding-left: 10px;
                        }
    
                        :last-child {
                            padding-right: 10px;
                        }
    
                        &.even {
                            background-color: #2E2E2E;
                        }
    
                        &:hover {
                            background-color: #444;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>